<div
    class="bg-white flex flex-col gap-8 rounded-medium p-6 shadow-[0_4px_18px_0_rgba(0,0,0,0.17)]">
    <!-- Header -->
    <div class="flex justify-between">
        <div class="flex justify-between ">
            <div class="flex flex-col gap-2">
                <h3 class="text-black font-semibold text-xl pb-2">{{labelName}}
                </h3>
            </div>
        </div>
        <div>
            <i class="icon-close" (click)="close()"></i>
        </div>
    </div>

    <!-- Body -->
    <div class="flex flex-col w-full max-h-96 overflow-y-auto" *ngIf="dropdownItems.length > 0">
        @for (item of dropdownItems; track $index) {
        <div class="flex py-5" (click)="selectModalItem(item)">
            <!-- Property Details -->
            <div class="flex flex-col flex-1 gap-3">
                <div class="flex flex-col gap-0.5">
                    <p class="text-md text-black font-semibold">
                        {{ item.title || 'Untitled' }}
                    </p>
                    @if (item.address) {
                    <p class="text-gray-900 text-xs">
                        {{ item.address }}
                    </p>
                    }
                </div>
                <div class="flex flex-col">
                    @if (item.extraInfo) {
                    <p class="text-gray-900 text-xs">
                        {{ item.extraInfo }}
                    </p>
                    }
                </div>
                <!-- Property Photo -->
                <div class="flex flex-col">
                    @if (item.defaultPhoto) {
                    <img class="h-[56px] w-[84px] rounded-[2px]"
                        [src]="item.defaultPhoto" alt="Property">
                    } @else {
                    <div
                        class="h-[56px] w-[84px] flex items-center justify-center bg-gray-200 rounded-[2px]">
                    </div>
                    }
                </div>
            </div>
            <!-- Checkbox -->
            <div class="flex pr-3">
                <label class="custom-radio">
                    <input type="radio" name="option"
                        [checked]="item.checked" />
                    <span class="radio-circle"></span>
                </label>
            </div>
        </div>
        <!-- Separator -->
        <div class="w-full last:hidden border-b border-gray-200 mx-auto"></div>     
        }
    </div>

</div>